
import { createLegalActivity } from "./legalActivityService";

type LegalActivityParams = {
  module: string; // e.g. "合約", "案件", "政府專案", "範本中心"
  docId: string;
  title: string;
  action: "新增" | "修改" | "刪除";
  userEmail: string;
  userId?: string; // Optional for backward compatibility, but preferred for new tasks
};

export async function logLegalActivityOnChange(params: LegalActivityParams) {
  const { module, docId, title, action, userEmail, userId } = params;

  // Map Chinese display names to System keys for correct WorkLogModule mapping
  const moduleMap: Record<string, string> = {
    "範本中心": "template",
    "合約": "contract",
    "案件": "case",
    "案件/爭議": "case",
    "智財權": "ip",
    "品牌資產": "brandAsset",
    "政府專案": "govProject",
    "用印申請": "sealRequest"
  };

  const systemSourceType = moduleMap[module] || "other";

  try {
    // Use the unified service to create both a Pending Task (Todo) and a History Log
    await createLegalActivity({
        sourceType: systemSourceType,
        sourceId: docId,
        title: `[${module}] ${action}：${title}`,
        actorUserId: userId || userEmail, // Use email as fallback ID if userId missing
        actorUserName: userEmail,
        
        // Critical: Set to true to ensure it appears in the "Pending Tasks" list
        todoRequired: true, 
        
        // Context
        description: `操作者: ${userEmail} \n動作: ${action}`,
        actionLabel: action === "修改" ? "UPDATE" : action === "新增" ? "CREATE" : "DELETE",
        
        // Default assignment (System or Self)
        assigneeName: userEmail,
        assigneeId: userId || "system"
    });

    console.log(`[LegalActivityLogger] Logged ${action} for ${module}: ${title}`);
  } catch (e) {
    console.error("[LegalActivityLogger] Failed to log activity", e);
  }
}
